import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { environment } from '../../environments/environment';
import { DocumentService } from '../services/document-service';
import { HttpEventType } from '@angular/common/http';
import { NotificationService } from '../services/notification-service';

@Component({
    selector: 'app-pdf-viewer',
    template: `
        <div class="pdf-container">
            <iframe [src]="pdfUrl" width="100%" height="100%" frameborder="0"></iframe>
        </div>
    `,
    styles: [`
        .pdf-container {
            width: 100%;
            max-width: 100%;
            height: 100%;
            border-radius: 10px;
        }
    `]
})
export class PdfViewerComponent implements OnInit {
    @Input() document: any;
    pdfUrl: SafeResourceUrl;

    constructor(
        private documentService: DocumentService,
        private dialogConfig: DynamicDialogConfig,
        private sanitizer: DomSanitizer,
        private notificationService: NotificationService
    ) {}

    ngOnInit() {
        if (this.dialogConfig) {
            this.document = this.dialogConfig.data.document;
        }
        this.loadPdf();
    }

    private loadPdf() {
        if (this.document.indCloudflare) {
            var progress = this.notificationService.showUploadProgress(this.document.nomFichier);
            // For Cloudflare documents, we need to fetch with auth
            this.documentService.ObtenirApercuCloudflare(this.document.cheminFichier).subscribe({
                next: (res) => {
                    if (res.type === HttpEventType.DownloadProgress) {
                        progress.next({progress: Math.round(res.loaded / res.total * 100), success: null});
                    }
                    if (res.type === HttpEventType.Response) {
                        const blob = new Blob([res.body], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob);
                        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
                        progress.next({progress: 100, success: true});
                    }
                },
                error: (err) => {
                    progress.next({progress: 100, success: false});
                    console.error('Error loading PDF:', err);
                }
            });
        } else {
            // For server documents, we can use the direct URL
            const endpoint = this.getEndpoint();
            const url = `${environment.apiDocumentUrl}${endpoint}/${this.document.cheminFichier}${this.document.cheminFichier ? '/' : ''}${this.document.nomFichier}`;
            this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }
    }

    private getEndpoint(): string {
        const typeLienDocument = this.document.typeLienDocument;
        let endpoint = "v"; // Default endpoint for viewing

        switch (typeLienDocument) {
            case 1: // Item
                endpoint += "";
                break;
            case 2: // BonTravail
                endpoint += "bt";
                break;
            case 3: // Requisition
                endpoint += "r";
                break;
            case 4: // NonConformite
                endpoint += "nc";
                break;
            case 5: // ItemCommande
                endpoint += "ic";
                break;
            case 6: // Location
                endpoint += "l";
                break;
            case 7: // Emplacement
                endpoint += "e";
                break;
        }

        return endpoint;
    }
} 